import React, { useState } from 'react';
import './package-list.css';
import { Box, Select, MenuItem, FormControl, Typography } from '@mui/material';

const CustomFilter = ({ sortByFilterOptions, onChange, isFullWidth }) => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    onChange(value);
  };

  return (
    <Box className="custom-filter-content-box">
      <FormControl
        sx={{
          minWidth: 120,
          mt: { xs: '20px', md: 0 }
        }}>
        <Select
          fullWidth={isFullWidth}
          value={selectedOption}
          onChange={handleChange}
          displayEmpty
          renderValue={(selected) => {
            const selectedLabel =
              sortByFilterOptions?.find((option) => option.value === selected)?.label ||
              'Select Sort Option';

            return (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography
                  component="span"
                  fontFamily="gothamBook"
                  lineHeight="20px"
                  color="#000000CC">
                  Sort by :
                </Typography>

                <Typography
                  component="span"
                  fontFamily="gothamBook"
                  fontSize={16}
                  lineHeight="20px"
                  color="#000">
                  {selectedLabel}
                </Typography>
              </Box>
            );
          }}
          MenuProps={{
            PaperProps: {
              style: {
                height: 'unset',
                maxHeight: '120px',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch'
              }
            }
          }}
          sx={{
            width: { md: '280px' },
            '& .MuiSelect-select': {
              px: '18px',
              py: '9px'
            },
            '& .MuiOutlinedInput-input': {
              minHeight: '20px',
              maxHeight: '20px'
            }
          }}>
          <MenuItem
            value=""
            sx={{
              fontFamily: 'gothamBook',
              fontSize: '14px',
              color: '#666'
            }}>
            Select Sort Option
          </MenuItem>

          {sortByFilterOptions?.length > 0 &&
            sortByFilterOptions.map((option, index) => (
              <MenuItem
                key={index}
                value={option.value}
                sx={{ fontFamily: 'gothamBook', fontSize: '14px' }}>
                {option.label}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CustomFilter;
